import script from "./Template.vue?vue&type=script&lang=ts&setup=true"
export * from "./Template.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__